/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../widgets/GridSectionHeader";

//DATA SLICE - REDUCER
import { updateTotals } from "../../../states/slcIncomeExpense.js";

import PageNavigator, { onNext } from "../../PageNavigator";

export default function Summary() {
  //FORM VALIDATATION STATUS
  const [isValid, setIsValid] = useState(false);

  //LOAD DATA FROM GLOBAL DATA MANAGER
  const annualIncome = useSelector((state) => state.incomeexpense.annualIncome);
  const annualExpenses = useSelector(
    (state) => state.incomeexpense.annualExpenses
  );
  const cpfInflowTotal = useSelector(
    (state) => state.incomeexpense.cpfInflowTotal
  );
  const cpfOutFlowTotal = useSelector(
    (state) => state.incomeexpense.cpfOutFlowTotal
  );
  var totalAnnualCashFlow = useSelector(
    (state) => state.incomeexpense.totalAnnualCashFlow
  );

  const totalassets = useSelector((state) => state.assetliability.totalassets);

  const totalliabilities = useSelector(
    (state) => state.assetliability.totalliabilities
  );

  const totalnetworth = useSelector(
    (state) => state.assetliability.totalnetworth
  );

  const riskType = useSelector((state) => state.investmentRisk.riskType);

  const ckacar = useSelector((state) => state.ckackr.result);
  console.log(ckacar);
  console.log(ckacar.isCkaPass);
  console.log(ckacar.isCarPass);
  const dispatch = useDispatch();

  useEffect(() => {
    totalAnnualCashFlow =
      Number(annualIncome).toFixed(2) -
      Number(annualExpenses).toFixed(2) +
      (Number(cpfInflowTotal).toFixed(2) - Number(cpfOutFlowTotal).toFixed(2));

    updateRedux(
      "totalAnnualCashFlow",
      totalAnnualCashFlow.toFixed(2),
      updateTotals
    );
  }, [annualIncome, annualExpenses, cpfInflowTotal, cpfOutFlowTotal]);

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  //CALLED WHEN "NEXT BUTTON" IS PRESSED. WHEN ATTEMPTING TO MOVE TO NEXT PAGE.
  function validateForm(e) {}

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        <Grid container spacing={2}>
          {/* SIMPLIFIED INCOME & EXPENSES */}
          <GridSectionHeader
            sectionName="Summary"
            sx={{
              p: 1,
              pl: 1.8,
              mt: 0,
              mb: 1,
              fontSize: 18,
              fontWeight: "bold",
              color: "#FFFFFF", //WHITE
              backgroundColor: "#10B981",
              width: "100%",
            }}
          />

          <Paper
            elevation={5}
            sx={{
              width: "49%",
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <List>
                  <ListItem>
                    <Grid size={12}>
                      <Typography variant="h6" align="center">
                        Inflow & Outflow
                      </Typography>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total Annual Inflow</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {annualIncome}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid size={8}>
                      <ListItemText> Total Annual Outflow</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {annualExpenses}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total CPF Inflow</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {cpfInflowTotal}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />
                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total CPF Outflow</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {cpfOutFlowTotal}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />

                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total Annual Cashflow</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {totalAnnualCashFlow}</ListItemText>
                    </Grid>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>

          <Paper
            elevation={5}
            sx={{
              width: "49%",
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <List>
                  <ListItem>
                    <Grid size={12}>
                      <Typography variant="h6" align="center">
                        Assets & Liabilities
                      </Typography>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total Assets</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {totalassets}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />

                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Total Liabilities</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {totalliabilities}</ListItemText>
                    </Grid>
                  </ListItem>
                  <Divider component="li" />

                  <ListItem>
                    <Grid size={8}>
                      <ListItemText>Networth</ListItemText>
                    </Grid>
                    <Grid size={4}>
                      <ListItemText>$ {totalnetworth}</ListItemText>
                    </Grid>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>

          <Paper
            elevation={5}
            sx={{
              width: "50%",
            }}
          >
            <Grid size={12}>
              <List>
                <ListItem>
                  <Grid size={12}>
                    <Typography variant="h6" align="center">
                      Risk Profile & CKA/CKR
                    </Typography>
                  </Grid>
                </ListItem>

                <ListItem>
                  <Grid size={8}>
                    <ListItemText>Risk Profile Type</ListItemText>
                  </Grid>
                  <Grid size={4}>
                    <ListItemText>{riskType}</ListItemText>
                  </Grid>
                </ListItem>
                <Divider component="li" />

                <ListItem>
                  <Grid size={8}>
                    <ListItemText>CKA Result</ListItemText>
                  </Grid>
                  <Grid size={4}>
                    <ListItemText>
                      {ckacar.isCkaPass ? "Passed" : "Failed"}
                    </ListItemText>
                  </Grid>
                </ListItem>
                <Divider component="li" />

                <ListItem>
                  <Grid size={8}>
                    <ListItemText>CAR Result</ListItemText>
                  </Grid>
                  <Grid size={4}>
                    <ListItemText>
                      {ckacar.isCarPass ? "Passed" : "Failed"}
                    </ListItemText>
                  </Grid>
                </ListItem>
                <Divider component="li" />
              </List>
            </Grid>
          </Paper>

          <Paper
            elevation={5}
            sx={{
              width: "100%",
            }}
          >
            <Grid size={12}>
              <List>
                <ListItem>
                  <Grid size={12}>
                    <Typography variant="h6" align="center">
                      Financial Objectives & Needs
                    </Typography>
                  </Grid>
                </ListItem>

                <ListItem>
                  <Grid size={12}>
                    <Typography variant="h6">High Priority</Typography>
                  </Grid>
                </ListItem>

                <ListItem>
                  <Grid size={12}>
                    <Typography variant="h6">Medium Priority</Typography>
                  </Grid>
                </ListItem>
              </List>
            </Grid>
          </Paper>
        </Grid>

        <PageNavigator validator={validateForm} isValid={isValid} />
      </Box>
    </>
  );
}
